import { STAGGER_MS } from "../../../lib/constants";

export const CaseImpact = ({ campaign: c }) => {
  return (
    <section className="hairline-b border-b bg-[var(--ink)] text-[var(--paper)]">
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-28">
        <div className="grid grid-cols-12 gap-6 mb-10 md:mb-16">
          <div className="col-span-12 md:col-span-8">
            <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
              The Impact
            </div>
            <h2 className="text-4xl md:text-7xl font-bold tracking-tight leading-[0.92]">
              The numbers<br />that landed
              <span className="text-[var(--accent)]">.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 border-l border-t border-white/15">
          {c.metrics.map((m, i) => (
            <div
              key={m.k}
              data-testid={`case-metric-${i}`}
              className="border-r border-b border-white/15 p-6 md:p-10 reveal"
              style={{ transitionDelay: `${i * STAGGER_MS}ms` }}
            >
              <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-8 md:mb-14">
                {m.k}
              </div>
              <div className="font-mono text-5xl md:text-7xl font-medium tracking-tighter leading-none">
                {m.v}
              </div>
            </div>
          ))}
        </div>

        {c.press && c.press.length > 0 && (
          <div className="mt-14 md:mt-20 hairline-t border-t border-white/15 pt-8 md:pt-10">
            <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-4">
              Coverage & Recognition
            </div>
            <div className="flex flex-wrap gap-x-4 gap-y-2 text-sm md:text-base tracking-tight font-medium">
              {c.press.map((p, pi) => (
                <span key={p} className="opacity-90">
                  {p}
                  {pi < c.press.length - 1 && (
                    <span className="opacity-40 ml-4">·</span>
                  )}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
